import { render, staticRenderFns } from "./EmployeeDetails.vue?vue&type=template&id=173f3f49"
import script from "./EmployeeDetails.vue?vue&type=script&lang=js"
export * from "./EmployeeDetails.vue?vue&type=script&lang=js"
import style0 from "./EmployeeDetails.vue?vue&type=style&index=0&id=173f3f49&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports